export default __webpack_public_path__ + "static/4-e78d4223c886636bf654ce9ed26cac3a.png";